import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Navbar from 'src/components/Navbar/Navbar'
import Footer from 'src/components/Footer/Footer'
import PostGraduateContent from 'src/components/PostGraduationContent/Residence2022/PostGraduate2022Content'
import PostGraduate2026Content from 'src/components/PostGraduationContent/Residence2026/PostGraduate2026Content'

const ViewPostGraduate = () => {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }, [])

  const content =
    location.pathname.split('/')[2] === 'rsc-2026' ? (
      <PostGraduate2026Content />
    ) : (
      <PostGraduateContent />
    )

  return (
    <>
      <Navbar />
      {content}
      <Footer />
    </>
  )
}

export default ViewPostGraduate
